// extracted by mini-css-extract-plugin
export default {"forgotPasswordWithRememberMe":"ForgotPassword_forgotPasswordWithRememberMe--bAy"};